import { MonthlyRollup, HometaxMonthRow, TumblbugMonthRow } from './types';

export interface TotalRow { month: string; taxable: number; exempt: number; total: number; }

export function combineRollups(rollups: MonthlyRollup[][], months: string[]): TotalRow[] {
  const acc = new Map<string, { taxable: number; exempt: number }>();
  months.forEach(m => acc.set(m, { taxable: 0, exempt: 0 }));
  for (const rollup of rollups) {
    for (const r of rollup) {
      const cur = acc.get(r.month);
      if (!cur) continue; // months 밖은 무시
      cur.taxable += r.taxable;
      cur.exempt += r.exempt;
    }
  }
  return months.map(m => {
    const v = acc.get(m)!;
    return { month: m, taxable: v.taxable, exempt: v.exempt, total: v.taxable + v.exempt };
  });
}

export function hometaxRollup(rows: HometaxMonthRow[]): MonthlyRollup[] {
  return rows.map(r => ({ month: r.month, taxable: r.taxable, exempt: r.exempt }));
}

// 텀블벅: 전부 면세
export function tumblbugRollup(rows: TumblbugMonthRow[]): MonthlyRollup[] {
  return rows.map(r => ({ month: r.month, taxable: 0, exempt: r.exempt }));
}
